module.exports = __webpack_public_path__ + "img/icon11.4017bc2a.png";